<template>
  <div :class="clsx('app-header-desktop', { 'animations-disabled': !animationEnabled })">
    <div class="app-header-desktop__logo">
      <Logo v-if="displayLogo" />
    </div>
    <div class="app-header-desktop__main-menu">
      <AppMainMenu
        :animation-enabled="animationEnabled"
        :routes="getMenuItems"
      />
    </div>
    <div class="app-header-desktop__controls button-group">
      <VioletFancyButton :route="{ name: 'login' }" class="app-header-desktop__button">
        Увійти
        <span class="app-header-desktop__login-icon">
          <LoginIcon />
        </span>
      </VioletFancyButton>
      <OrangeFancyButtonWithArrowAnimation :route="{ name: 'promo' }" hash="#contacts" class="app-header-desktop__button app-header-desktop__connect-button">
        Зв’язатися
      </OrangeFancyButtonWithArrowAnimation>
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import Logo from '../logo';
import { OrangeFancyButtonWithArrowAnimation, VioletFancyButton } from '@/shared/ui/form/buttons';
import { LoginIcon } from '@/shared/ui/icons';
import { HashAnchor } from '@/shared/ui/link';
import { MainMenuItems } from '@/widgets/promo';
import AppMainMenu from '@/widgets/promo/ui/app-main-menu';

export default {
  props: {
    displayLogo: {
      type: Boolean,
      default: true,
    },
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: { Logo, AppMainMenu, OrangeFancyButtonWithArrowAnimation, VioletFancyButton, LoginIcon, HashAnchor },
  computed: {
    getMenuItems() {
      return MainMenuItems;
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.app-header-desktop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 56px;
  background: linear-gradient(to bottom, #CADDFC 0px, #CADDFC 70px, rgba(202, 221, 252, 0) 90px);
  margin-bottom: -10px;

  &__controls {
    display: flex;
    opacity: 0;
    transform: scale(0.7);
    animation-fill-mode: both;
    animation: header-controls-animation 0.5s linear forwards;
    animation-delay: 1s;
    pointer-events: auto !important;
  }

  &__logo {
    animation: small-logo-animation 1s linear forwards;
  }

  &__login-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;
    transform: translateX(0);
    transition: transform .5s;
  }
}

.button-group > * + * {
  margin-left: 16px;
}

.app-header-desktop__connect-button:hover {
  .app-header-desktop__login-icon {
    transform: translateX(100%);
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .app-header-desktop__controls {
    opacity: 1;
    transform: scale(1);
  }

  .app-header-desktop__logo {
    transform: translateX(0%);
  }
}

@keyframes small-logo-animation {
  from {
    transform: translateX(45vw);
  }
  to {
    transform: translateX(0%);
  }
}

@keyframes header-controls-animation {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes show-animation {
  0% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
